<template>
  <pt-customer-detail class="pt-customer-detail__withData"  v-loading="loading" :vendor="currentVendor"></pt-customer-detail>
</template>

<script>
import PtCustomerDetail from './index'
export default {
  name: 'pt-customer-detail__withData',
  components: {
    'pt-customer-detail': PtCustomerDetail
  },
  data () {
    return {
      loading: false,
      currentVendor: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getVendor', this.$route.params.id).then(data => {
        this.loading = false
        this.currentVendor = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
